import React from "react";
import api from "../../Shared/Functions/APIHelpers";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import BusinessIcon from "@material-ui/icons/Business";
import MedicareIcon from "@material-ui/icons/LocalHospital";
import TerminationIcon from "@material-ui/icons/Cancel";
import PeopleIcon from "@material-ui/icons/People";
import PersonIcon from "@material-ui/icons/Person";
import Agreement from "../../Shared/Components/Agreement/Agreement";

const initialState = {
  loaded: false,
};

class SarPassThrough extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  reset() {
    this.setState(initialState);
  }

  componentDidMount() {
    var portalID = this.getPortalID();
    var sarID = this.getSARID();
    this.setState({ portalID: portalID, sarID: sarID });

    this.updateSARRecord(portalID, sarID).then((r) => {
      this.redirectScreen();
      this.setState({ loaded: true });
    });
  }

  getPortalID = () => {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    return params.get("portalID") ? params.get("portalID") : null;
  };

  getSARID = () => {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    return params.get("sarID") ? params.get("sarID") : null;
  };

  updateSARRecord = (portalID, sarID) => {
    let body = {
      sarID: sarID,
    };
    return new Promise((resolve, reject) => {
      if (this.props.employerIsSecured)
        resolve(api.updateSARRecordOpenSecured(portalID, JSON.stringify(body)));
      else resolve(api.updateSARRecordOpen(portalID, JSON.stringify(body)));
    });
  };

  redirectScreen = () => {
    this.props.history.push(
      "/employer/documents" + this.props.history.location.search
    );
  };

  render() {
    const { loaded } = this.state;

    if (!loaded) return null;

    return <React.Fragment>SAR</React.Fragment>;
  }
}

export default SarPassThrough;
